import { useTranslation } from 'react-i18next'
import { common } from '@ocean/ui'
import { Root, Content, Name } from './User.styled'

const { Typography, UserIcon } = common

type UserProps = {
  name: string
  onLogout: Callback
}

const User: React.FC<UserProps> = ({ name, onLogout }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <UserIcon userName={name} dataTest='SidebarUserIcon' />
      <Content>
        <Name>
          <Typography variant='h3' dataTest='SidebarUserName'>
            {name}
          </Typography>
        </Name>
        <Typography
          variant='h3'
          onClick={onLogout}
          underline
          hover='oceanLight'
          data-test='SidebarLogoutButton'
        >
          {t('navigation.logout')}
        </Typography>
      </Content>
    </Root>
  )
}

export default User
